import { get } from '@/utils/https'

// 获取商品
export const getCata = () => get('/mall/cata')

// 获取品类
export const getData = () => get('/mall/data')

// 获取商铺
export const getShop = () => get('/mall/shop')


// WEBPACK FOOTER //
// ./src/api/mall.js